<template>
  <div class="modal fade" id="customerModal" tabindex="-1" aria-labelledby="customerModalLabel" data-bs-backdrop="static" @keydown.esc="clearForm">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="clientModalLabel">{{ clientType !== 3 ? 'Клиент' : 'Выгодоприобретатель' }}</h5>
          <button type="button" @click="clearForm" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <template v-if="valid && !dBrainClient && !!info[0]">
            <div v-if="!validFields" class="alert alert-dismissible bg-danger d-flex flex-column flex-sm-row w-100 p-5 mb-5">
              <div class="d-flex flex-column text-light pe-0 pe-sm-10">
                <span v-html="errorMessage"></span>
              </div>
            </div>
            <customer-card
                v-for="(client, key) in this.info"
                :key="key"
                :client="client"
                :selected-client="this.selectedClient === key"
                :key-item="key"
                :has-paid="hasPaid"
                :module="module"
                @setSelectedClient="setSelectedClient"
                @isEdited="isEdited"
                :class="{'border-success': key === selectedClient && validFields, 'border-danger': key === selectedClient && !validFields }"
                class="cursor-pointer"
            >
              <template v-slot:change>
                <span v-if="!client.entrepreneur" class="edit-item" @click="isEdited(true)">
                  <i class="ki-outline ki-notepad-edit"></i>
                </span>
              </template>
              <template v-if="clientType !== 3" v-slot:footer>
                <div class="border-top p-5">
                  <checkbox-field
                      v-if="this.module.Modal.infoBlock('driver', clientType) && !info[0].entrepreneur && info[0].filter.person"
                      v-model="client.driver.experience"
                      placeholder="Стаж менее 2-х лет"
                      :name="'driver_experience_'+key"
                      :id="'driver_experience_'+key"
                      class="form-check-sm mb-3"
                      @click="checkExperience(client.driver)"
                  />
                  <checkbox-field
                      v-if="this.module.Modal.infoBlock('driver', clientType) && !info[0].entrepreneur && info[0].filter.person && info[0].filter.resident"
                      v-model="client.driver.pensioner"
                      placeholder="Льготы для ветеранов, инвалидов 1-2 группы и пенсионеров"
                      :name="'driver_pensioner_'+key"
                      :id="'driver_pensioner_'+key"
                      class="form-check-sm mb-3"
                  />
                  <checkbox-field
                      v-if="this.module.Modal.infoBlock('politician', clientType)"
                      v-model="client.client.politician"
                      placeholder="ИПДЛ"
                      :name="'driver_pensioner_'+key"
                      :id="'driver_politician_'+key"
                      class="form-check-sm question-mini-icon"
                      title="Публичное должностное лицо"
                  />
                </div>
                <customer-entrepreneurs
                    v-if="this.module.Modal.infoBlock('entrepreneur', clientType) && client.filter.person && client.filter.resident"
                    data-history="client.filter.person && client.filter.resident"
                    :entrepreneur="client.entrepreneur ?? null"
                    :is-edit="this.isEdit"
                    :activity-kinds="this.activity_kinds"
                    @selectedEntrepreneur="selectedEntrepreneur"
                />
                <customer-bank
                    v-if="this.module.Modal.infoBlock('bank', clientType)"
                    :bank="client.bank"
                    :is-person="client.filter.person"
                    :is-resident="client.filter.resident"
                    @selectedBank="selectedBank"
                    :module="module"
                />
              </template>
            </customer-card>
            <button v-if="!isEdit" class="btn btn-light-danger btn-sm w-100" @click="clearForm">Очистить</button>
          </template>
          <template v-else-if="dBrainClient">
            <template v-for="(client, key) in this.info"
                      :key="key">
              <customer-card
                  :client="client"
                  :selected-client="this.selectedClient === key"
                  :key-item="key"
                  :module="module"
                  :has-paid="hasPaid"
                  @setSelectedClient="setSelectedClient"
                  @isEdited="isEdited"
                  :class="key === selectedClient ? 'border-success mb-0' : ''"
                  class="cursor-pointer"
              >
                <template v-slot:additional>
                  <span class="text-danger opacity-75"> / {{ client.client.sex === 1 ? 'Муж.' : client.client.sex === 2 ? 'Жен.' : '' }}</span>
                </template>
              </customer-card>
              <customer-change
                  v-if="this.selectedClient === key"
                  :client="client"
                  :dBrainClient="dBrainClient"
              />
            </template>
          </template>
          <template v-else>
            <customer-search
                v-if="search.step === 0"
                @createClient="createClient"
                :is-clear="clear"
                :client-added-list="this.clientAddedList"
                :after-set="this.afterSet"
                :client-type="this.clientType"
                :filter-settings="this.filterSettings"
                :product-type="this.productType"
                :ulid="ulid"
                :module="module"
            />
            <customer-data
                v-if="search.step >= 1"
                @changeFilterStep="changeFilterStep"
                @updateClientData="updateClientData"
                @closeClientData="closeClientData"
                :data-client="info[selectedClient]"
                :search-data="search.data"
                :activity-kinds="this.activity_kinds"
                :is-clear="clear"
                :is-edit="isEdit"
                :module="module"
            />
          </template>
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <button
              @click="clearForm"
              type="button"
              class="btn btn-sm btn-secondary"
              data-bs-dismiss="modal"
          >Закрыть</button>
          <button
              v-if="(valid && this.info[this.selectedClient].filter.verify && this.info[this.selectedClient].filter.resident) || (valid && !this.info[this.selectedClient].filter.resident) && !dBrainClient"
              @click="addClient"
              type="button"
              :disabled="!validFields"
              class="btn btn-sm btn-primary"
              v-html="this.search.step === 1 ? 'Добавить' : this.isEdit ? 'Сохранить' : 'Создать'">
          </button>
          <div v-if="dBrainClient">
            <button
                v-if="uidbError"
                @click="createClientFromScan(scan)"
                type="button"
                class="btn btn-sm btn-primary me-2"
                v-html="'Создать нового клиента'">
            </button>
            <button
                @click="rewriteClient"
                type="button"
                :disabled="selectedClient === null"
                class="btn btn-sm btn-primary"
                v-html="'Обновить данные'">
            </button>
          </div>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
// Form
import CustomerEntrepreneurs from '@/components/Form/Customer/CustomerEntrepreneurs'
import CustomerSearch        from '@/components/Form/Customer/CustomerSearch'
import CustomerData          from '@/components/Form/Customer/CustomerData'
import CustomerCard          from '@/components/Form/Customer/CustomerCard'
import CustomerBank          from '@/components/Form/Customer/CustomerBank'
// Field
import CheckboxField from '@/components/Fields/CheckboxField'
// Other
import LoaderFull   from '@/components/Main/LoaderFull'
import dBrain       from '@/helpers/dBrain';
import axios        from 'axios'
import CustomerDocumentCard from "@/components/Form/Customer/CustomerDocumentCard.vue";
import CustomerChange from "@/components/Form/Customer/CustomerChange.vue";

export default {
  name: 'CustomerModal',
  components: {
    CustomerDocumentCard,
    CustomerChange,
    CustomerEntrepreneurs,
    CustomerSearch,
    CheckboxField,
    CustomerBank,
    CustomerData,
    CustomerCard,
    LoaderFull,
  },
  props: {
    clientAddedList: {
      type: Array,
      default: () => []
    },
    client: {
      type: Object,
      default: null
    },
    productType: {
      type: Number,
      default: 0
    },
    module: {
      type: Function,
      required: true
    },
    hasPaid: {
      type: Boolean,
      default: true
    },
    ulid: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      search: {
        data: null,
        step: 0
      },
      clientType:     0,
      selectedClient: 0,
      filterStep:     0,
      isEdit:         false,
      clear:          false,
      valid:          false,
      validFields:    false,
      info:           {0:{}},
      dBrainClient:   null,
      scan:           null,
      loader:         false,
      afterSet:       null,
      entrepreneur:   null,
      filterSettings: null,
      uidbError:      false,
      errorMessage:   null,
      activity_kinds: null
    }
  },
  methods: {
    closeClientData(val) {
      if (this.info[0].hasOwnProperty('client')) {
        this.valid = val === 1
      } else {
        this.valid        = false
        this.search.step  = 0
      }
    },
    selectedEntrepreneur(val) {
      if (val !== 'undefined') {
        this.info[0]['entrepreneur'] = val
      } else {
        if (this.info[0].hasOwnProperty('entrepreneur')) delete this.info[0]['entrepreneur']
      }
    },
    updateClientData(val) {
      if (this.info[0].hasOwnProperty('client')) {
        Object.entries(val).forEach(([key, value]) => {
          if (key !== 'podft') {
            if (this.info[0].hasOwnProperty(key)) this.info[0][key] = value
          }
          if (key === 'location' && value) this.info[0]['client'] = Object.assign(this.info[0]['client'], value)
        })
        const validStatus = this.module.Validator.validateClient(this.info[this.selectedClient])
        this.valid        = validStatus.result
        this.validFields  = validStatus.result
        this.errorMessage = validStatus.result ? null : validStatus.message
      } else {
        this.search.step  = 0
        this.afterSet     = {main: this.search.data.client, filter: this.search.data.filter}
        if (!val.filter.resident) {
          if (this.module.Modal.infoBlock('driver', this.clientType)) {
            let driver = {
              age_experience_id: 0,
              experience:        false,
              pensioner:         false,
              age:               0,
            }
            driver.age                = this.calculateAge(val.client.birthday)
            driver.age_experience_id  = driver.age >= 25 ? 4 : 2
            val['driver']             = structuredClone(driver)
          }
          if (this.module.Modal.infoBlock('bank', this.clientType)) {
            let bank = {
              name: null,
              kbe:  null,
              bik:  null,
              iik:  null,
            }
            val['bank'] = structuredClone(bank)
          }
          val['beingVerify']        = false
          this.createClient({data:[val], step: 1})
        }
      }
    },
    calculateAge(birthday) {
      if (!birthday) return 0;

      const birthDate = new Date(birthday);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();

      const birthdayPassed =
          today.getMonth() > birthDate.getMonth() ||
          (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

      if (!birthdayPassed) {
        age--;
      }

      return age;
    },
    changeFilterStep (val) {
      this.filterStep = val
    },
    modalHidden() {
      const myModalEl = document.getElementById('customerModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    },
    clearForm() {
      this.entrepreneur   = null
      this.selectedClient = 0
      this.search.data    = null
      this.search.step    = 0
      this.search.edited  = null
      this.clear          = true
      this.valid          = false
      this.isEdit         = false
      this.info           = {0:{}}
      this.dBrainClient   = null
      this.scan           = null
      if (this.clear) {
        this.$emit('clearClient', this.clear)
        setTimeout(() => {this.clear = false}, 50)
      }
    },
    addClient() {
      const data = { clientType: this.clientType, key: this.search.edited ? this.search.edited.key : null, data: this.info[this.selectedClient] };
      let isSuccess = false
      this.loader = true
      if (this.module.Modal.isOgpo()) {
        this.setClientSimple()
            .then(res => {
              if (res.data.result) {
                if (data.hasOwnProperty('data')) {
                  if (!data.data.filter.person) {
                    if (!data.data.client.name) data.data.client.name = data.data.client.title
                  }
                } else {
                  if (!data.filter.person) {
                    if (!data.client.name) data.client.name = data.client.title
                  }
                }
                isSuccess = true
              } else {
                this.$notifyError(res.data)
              }})
            .catch(err => {
              this.$notifyError(err)
            })
            .finally(() => {
              if (isSuccess) {
                this.sendToMain(data)
                this.loader = false
              } else this.loader = false
            })
      } else {
        if (data.hasOwnProperty('data')) {
          if (!data.data.filter.person) {
            if (!data.data.client.name) data.data.client.name = data.data.client.title
          }
        } else {
          if (!data.filter.person) {
            if (!data.client.name) data.client.name = data.client.title
          }
        }
        this.sendToMain(data)
        this.loader = false
      }
    },
    sendToMain(data) {
      this.$emit('addClient', data)
      setTimeout(() => { this.clearForm() }, 100)
      this.modalHidden()
    },
    createClientFromScan(val) {
      this.createClient({data: {data: val, result: 1}, step:2})
      this.valid        = false
      this.info         = {0: {}}
      this.dBrainClient = null
    },
    createClient(val) {
      this.getActivityKind()
      this.search.step = val.step
      if (val.data[0] && val.data[0].entrepreneur !== 'undefined') {
        this.entrepreneur = val.data[0].entrepreneur
        delete val.data[0].entrepreneur
      }
      if (val.step === 2) {
        this.search.data  = val.data
      } else {
        this.search.data  = null
        this.info         = val.data
        this.dBrainClient = val.scan ? dBrain.clientData(val.scan) : null
        this.scan         = val.scan ?? null
      }
    },
    getActivityKind() {
      this.loader = true
      axios.get('/api/dictionaries/activity-kinds')
          .then(res => {
            this.activity_kinds = res.data
          })
          .finally(() => {this.loader = false})
    },
    rewriteClient() {
      this.replaceValues(this.info[this.selectedClient], this.dBrainClient, false);
      this.info           = [this.info[this.selectedClient]]
      this.selectedClient = 0
      this.loader         = true
      this.setClientSimple().then(
          res => {
            if (res.data.result) {
              this.replaceValues(this.info[0], res.data.data, true);
              this.info[0]['client']['id'] = res.data.data.client.id
              this.dBrainClient = null
              this.scan         = null
            } else {
              let haystack = res.data.hasOwnProperty('errors') ? res.data.errors[0] : res.data.message
              let needle   = /Данный клиент присутствует в полисах, введенных после 01\.01\.2011/
              if(needle.test(haystack)) {
                this.uidbError = true
              }
              this.$notifyError(res.data)
            }})
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => this.loader = false)
    },
    replaceValues(target, source, changeId = false, path = "") {
      for (const key in target) {
        if (source.hasOwnProperty(key)) {
          const fullPath = path ? `${path}.${key}` : key;
          if (!changeId && fullPath === 'client.id') continue

          if (typeof target[key] === "object" && target[key] !== null && !Array.isArray(target[key])) {
            this.replaceValues(target[key], source[key], changeId, fullPath);
          } else {
            if (target[key] !== source[key] && source[key] !== undefined && source[key] !== null && source[key] !== '') {
              target[key] = source[key];
            }
          }
        }
      }
    },
    async setClientSimple() {
      let headers = structuredClone(this.info)
      if (!headers[0].filter.person) headers[0].client.name = headers[0].client.title
      return await axios.post('/api/client/set', headers)
    },
    checkExperience(item) {
      item.age_experience_id = this.experience(item.age, !item.experience)
    },
    experience(age, experience) {
      // 1 = младше 25 лет стаж меньше 2
      // 2 = младше 25 лет стаж больше 2
      // 3 = больше 25 лет стаж меньше 2
      // 4 = больше 25 лет стаж больше 2
      if (parseInt(age) < 25) {
        return experience ? 1 : 2
      } else {
        return experience ? 3 : 4
      }
    },
    isEdited(val) {
      // this.isEdit = val
      this.valid  = !val
    },
    selectedBank(val) {
      if (!this.isEdit) {
        if (val !== 'undefined') { this.info[0]['bank'] = val; }
        else { if (this.info[0].hasOwnProperty('bank')) delete this.info[0]['bank']; }
      }
    },
    setSelectedClient(val) {
      this.selectedClient = val
    },
  },
  watch: {
    info: {
      deep: true,
      handler(val) {
        if (!this.isEdit) {
          if (!this.info[0]) this.info = {0: {}}
          let validStatus        = this.module.Validator.validateClient(val[this.selectedClient])
          if (Array.isArray(val)) {
            this.valid             = val.length <= 1 ? this.module.Validator.validateFill([val[this.selectedClient]]).result : true;
          } else {
            this.valid             = this.module.Validator.clientByInfoAndSearchStep(this.search.step, val[this.selectedClient]) && this.module.Validator.validateFill([val[this.selectedClient]]).result;
          }
          this.validFields       = validStatus.result;
          this.errorMessage      = validStatus.result ? null : validStatus.message
        }
      }
    },
    selectedClient(val) {
      let validStatus        = this.module.Validator.validateClient(this.info[this.selectedClient])
      this.validFields       = validStatus.result
      this.errorMessage      = validStatus.result ? null : validStatus.message
    },
    client: {
      deep: true,
      handler(val) {
        if (val.data) {
          this.info              = {0:val.data}
          let validStatus        = this.module.Validator.validateClient(this.info[this.selectedClient])
          this.valid             = val.length <= 1 ? this.module.Validator.validateFill([this.info[this.selectedClient]]).result : true;
          this.validFields       = validStatus.result;
          this.errorMessage      = validStatus.result ? null : validStatus.message
          this.isEdit      = true
          this.search.step = 3
          this.search['edited'] = {key:val.key, isInsurer:val.clientType === 1}
        } else {
          this.clearForm()
        }
        this.clientType = val.clientType;
        this.filterSettings = this.productType
            ? this.module.Client.filterByProductType(this.productType, this.clientType)
            : this.module.Client.modalFilterSettings(this.clientType)
      }
    }
  }
}
</script>

<style scoped>

</style>